import type { LabReading, LabResult, StatusIndicator } from "../types";
import { STATUS_FILTERS } from "../constants";
import { LabStatusFilterChip } from "../atoms/LabStatusFilterChip";
import { cn } from "../../../lib/utils";

export interface LabStatusFilterBarProps {
  results: LabResult[];
  activeFilters: StatusIndicator[];
  onFilterChange: (filters: StatusIndicator[]) => void;
  getReading?: (result: LabResult) => LabReading | undefined;
  className?: string;
}

const defaultGetReading = (result: LabResult): LabReading | undefined => result.readings[0];

export const LabStatusFilterBar = ({
  results,
  activeFilters,
  onFilterChange,
  getReading = defaultGetReading,
  className,
}: LabStatusFilterBarProps) => {
  const toggle = (key: StatusIndicator) => {
    if (activeFilters.includes(key)) {
      onFilterChange(activeFilters.filter((f) => f !== key));
    } else {
      onFilterChange([...activeFilters, key]);
    }
  };

  return (
    <div data-slot="lab-status-filter-bar" className={cn("flex items-center gap-2", className)}>
      {STATUS_FILTERS.map(({ key, label, dotClass, activeClass }) => (
        <LabStatusFilterChip
          key={key}
          label={label}
          count={results.filter((r) => getReading(r)?.statusIndicator === key).length}
          active={activeFilters.includes(key)}
          colorClass={dotClass}
          activeColorClass={activeClass}
          onClick={() => toggle(key)}
        />
      ))}
    </div>
  );
};
